import { jsx as _jsx } from "react/jsx-runtime";
import { useToast as useChakraToast } from '@chakra-ui/react';
import { Alert } from '@sgi/gravity';
export const useToast = () => {
    const toast = useChakraToast();
    const showToast = ({ description, duration = 5000, position = 'top-right', showCloseButton = true, status = 'info', ...rest }) => {
        toast({
            duration: duration,
            position: position,
            render: ({ id, onClose }) => (_jsx(Alert, { status: status, id: id ? `toast-${id}` : undefined, onClose: onClose, showCloseButton: showCloseButton, variant: "toast", ...rest, children: description })),
        });
    };
    const showInfoToast = (props) => {
        showToast({ status: 'info', ...props });
    };
    const showWarningToast = (props) => {
        showToast({ status: 'warning', ...props });
    };
    const showSuccessToast = (props) => {
        showToast({ status: 'success', ...props });
    };
    const showErrorToast = (props) => {
        showToast({ status: 'error', ...props });
    };
    return { showToast, showInfoToast, showWarningToast, showSuccessToast, showErrorToast };
};
